/**
 * DataSourceSurfaceContext - the data-source page's binding of the shared
 * detail-surface context.
 *
 * The machinery (an optional context, a typed API) is in
 * `shared/surface/DetailSurfaceContext`. What is particular here is one type:
 * which pane ids exist.
 *
 * NO SELECTION AND NO READER. The page edits its record inline on the Details
 * tab and selects no row, and opening a file still goes to the shared global
 * `reader` side panel. So it takes `DetailSurfaceApiWithoutSelection` with the
 * default `Reader = never`: `openReader` cannot typecheck, which is the truth
 * - there is nowhere on this surface to put it.
 *
 * IT IS OPTIONAL ON PURPOSE. `useDataSourceSurface()` returns null outside the
 * provider, so a tab component rendered anywhere else keeps working.
 */

import {
  DetailSurfaceApiWithoutSelection,
  createDetailSurfaceContext,
} from '../../../shared/surface/DetailSurfaceContext';
import { DataSourcePanelId } from './layout';

export type DataSourceSurfaceApi =
  DetailSurfaceApiWithoutSelection<DataSourcePanelId>;

const binding = createDetailSurfaceContext<DataSourceSurfaceApi>();

export const DataSourceSurfaceProvider = binding.Provider;

/** Null outside the data-source surface - callers keep their old behaviour. */
export const useDataSourceSurface = binding.useSurface;

export default binding.Context;
